import styled from "styled-components"

export const RoundImg = styled.img`
    align-self: center;
    justify-self: center;
    height: 78%;
    margin: 10px 20px;
`